import rightArrowLogo from "common/assets/arrow_right.svg";
import { ListContainer } from "common/components/lists/ListContainer";
import { ListItem } from "common/components/lists/ListItem";
import gql from "graphql-tag";
import React from "react";
import { Link } from "react-router-dom";
import { ContentListFragment } from "__generated__/types";
import styles from "./ContentList.module.css";

gql`
  fragment ContentListFragment on Content {
    id
    title
    status
  }
`;

interface Props {
  contentList: ContentListFragment[];
  getUrl: (id: string) => string;
  noDataText: string;
}

export const ContentList: React.FC<React.PropsWithChildren<Props>> = ({
  contentList,
  getUrl,
  noDataText,
}) => {
  return (
    <ListContainer className={styles.folderList}>
      {contentList.map((element) => (
        <ListItem key={element.id}>
          <Link to={getUrl(element.id)}>
            <div className={styles.container}>
              <h3 className={styles.title}>{element.title}</h3>
              <div className={styles.arrow}>
                <img src={rightArrowLogo} alt="right-arrow" />
              </div>
            </div>
          </Link>
        </ListItem>
      ))}
      {contentList.length === 0 && noDataText}
    </ListContainer>
  );
};
